import { rootSaga, reducer } from './_redux';

const loadInterface = () => import('./Interface');

export { rootSaga, reducer, loadInterface };
